module.exports = __webpack_public_path__ + "static/media/selbourne 2.eba3c351.jpg";